// Plugins
import { registerPlugins } from '@/plugins'

// QuillJS Styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

const app = createApp(App)

registerPlugins(app)

app.mount('#app')
